<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://www.hrtec.net/"
            target="_blank"
            rel="noopener"
            class="nav-link">
            HRTec.net
          </a>
        </li>
        <li class="nav-item">
          <a
            href="https://www.fedhive.com/"
            target="_blank"
            rel="noopener"
            class="nav-link">
            FedHIVE
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }}, HRTec, Inc. | Human Resource Technologies, Inc.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
